module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "line.4d72ed01.png" + "?" + Date.now();